var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2083 13.6944H3.12492C2.13541 13.6944 1.33325 14.4966 1.33325 15.4861C1.33325 16.4756 2.13541 17.2777 3.12492 17.2777H28.2083C29.1978 17.2777 29.9999 16.4756 29.9999 15.4861C29.9999 14.4966 29.1978 13.6944 28.2083 13.6944Z",
    fill: "#001E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12492 8.91665H28.2083C29.1978 8.91665 29.9999 8.11448 29.9999 7.12498C29.9999 6.13548 29.1978 5.33331 28.2083 5.33331H3.12492C2.13541 5.33331 1.33325 6.13548 1.33325 7.12498C1.33325 8.11448 2.13541 8.91665 3.12492 8.91665Z",
    fill: "#001E32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2083 22.0555H3.12492C2.13541 22.0555 1.33325 22.8577 1.33325 23.8472C1.33325 24.8367 2.13541 25.6389 3.12492 25.6389H28.2083C29.1978 25.6389 29.9999 24.8367 29.9999 23.8472C29.9999 22.8577 29.1978 22.0555 28.2083 22.0555Z",
    fill: "#001E32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.3e4b213ffa002fb2bfdca5222873c340.svg";
export { ForwardRef as ReactComponent };